import React from 'react';

import MessageCampaignContentPreviewCard from 'components/message/MessageCampaignContentPreviewCard';
import { CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';

// eslint-disable-next-line no-unused-vars

export const CREATE_MESSAGE_CAMPAIGN_PREVIEW_PAGE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch, getValues } }) => {
    const displayLanguageSectionComponents = [
      'campaign_content_section_key',
    ];
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageExtraTopSection: () => (
    <div id={CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage} />
  ),
  languageSections: [
    {
      sectionContent: [
        {
          key: 'campaign_content_section_key',
          complexComponent: ({ formContext: { getValues }, language }) => (
            <MessageCampaignContentPreviewCard
              language={language}
              campaignData={getValues()}
            />
          ),
        },
      ],
    },
  ],
};
